import React from "react";
import {
  Grid,
  TextField,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Divider,
  IconButton,
  Dialog,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CustomTypography from "../../globalStyles/fonts";

const CountryDetailsModal = ({ country, open, onClose }) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <DialogTitle>Country Details</DialogTitle>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            width: "100%",
          }}
        >
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </div>
      </div>
      <Divider style={{ marginBottom: "10px" }} />
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <CustomTypography
              color={"var(--text-heading)"}
              fontSize={14}
              fontWeight={400}
            >
              Name
            </CustomTypography>
            <TextField
              size="small"
              margin="dense"
              variant="outlined"
              type="text"
              fullWidth
              value={country?.name || ""}
              sx={{
                "& .MuiInputBase-input": {
                  color: "var(--text-secondary)",
                },
                "& .MuiOutlinedInput-root": {
                  backgroundColor: "var(--bg-input)",
                },
              }}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <CustomTypography
              color={"var(--text-heading)"}
              fontSize={14}
              fontWeight={400}
            >
              Code2
            </CustomTypography>
            <TextField
              size="small"
              margin="dense"
              variant="outlined"
              type="text"
              fullWidth
              value={country?.code2 || ""}
              sx={{
                "& .MuiInputBase-input": {
                  color: "var(--text-secondary)",
                },
                "& .MuiOutlinedInput-root": {
                  backgroundColor: "var(--bg-input)",
                },
              }}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <CustomTypography
              color={"var(--text-heading)"}
              fontSize={14}
              fontWeight={400}
            >
              Code3
            </CustomTypography>
            <TextField
              size="small"
              margin="dense"
              variant="outlined"
              type="text"
              fullWidth
              value={country?.code3 || ""}
              sx={{
                "& .MuiInputBase-input": {
                  color: "var(--text-secondary)",
                },
                "& .MuiOutlinedInput-root": {
                  backgroundColor: "var(--bg-input)",
                },
              }}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions style={{ padding: 10 }}>
        <Button
          onClick={onClose}
          variant="outlined"
          style={{ textTransform: "none" }}
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CountryDetailsModal;
